import React, { PureComponent } from 'react';
import { compose, withProps } from 'recompose';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';
import isEqual from 'lodash/isEqual';

import { MAP_OPTIONS, ZOOM_LEVELS } from 'shared/constants/map';
import { toGoogleCoordinates } from 'shared/helpers/coordinates';
import getBoundariesFromGoogleMap from 'shared/helpers/map/getBoundariesFromGoogleMap';
import ConfigHelperHOC from '../ConfigHelperHOC';

/**
 * This component uses react-google-maps node_module
 * Documentation: https://tomchentw.github.io/react-google-maps
 */
class MapContainer extends PureComponent {
  state = {
    zoom: ZOOM_LEVELS.DEFAULT,
    center: null
  };

  /**
   * Map centering
   *
   * Priority is given to the selectedShopCenter if exits
   * If not, we use the controlled center props if exits (User has already touched the map)
   * If not, we use the user coordinates
   * If not (first render only) we use the defaultCenter.
   */
  get center() {
    const { center } = this.state;
    const { defaultCenter, center: forcedCenter, userCoordinates } = this.props;
    return (
      forcedCenter ||
      center ||
      toGoogleCoordinates(userCoordinates) ||
      defaultCenter
    );
  }

  /**
   * Map zoom level
   *
   * A zoom level can be arbitrary set
   * If not, we use the controlled zoom props which has a default if value map zoom has not been touched yet.
   */
  get zoom() {
    const { zoom } = this.state;
    const { zoom: forcedZoom } = this.props;
    return forcedZoom || zoom;
  }

  constructor(props) {
    super(props);

    this.mapRef = undefined;
  }

  UNSAFE_componentWillMount() {
    const { bounds } = this.props;
    /* const { mapRef: map, handleZoomChange, handleCenterChange } = this; */

    if (bounds) {
      // TODO: resolve boundaries on mount
      // map.fitBounds(bounds, 20);
      // set bounds then saves zoom and center in state
      // handleZoomChange(map.getZoom());
      // handleCenterChange(map.getCenter());
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { bounds } = this.props;
    const { bounds: nextBounds } = nextProps;
    const { mapRef: map } = this;

    // on bounds change, move view
    if (!isEqual(bounds, nextBounds) && nextBounds) {
      map.fitBounds(nextBounds, 20);
      // set bounds then saves zoom and center in state
      this.setState({
        zoom: map.getZoom(),
        center: map.getCenter()
      });
    }

    // on user coordinates change, move view
    if (!isEqual(this.props.userCoordinates, nextProps.userCoordinates)) {
      this.setState({
        zoom: ZOOM_LEVELS.CLOSE,
        center: toGoogleCoordinates(nextProps.userCoordinates)
      });
    }
  }

  handleMapRef = mapRef => {
    const { onRefResolve = () => {} } = this.props;
    this.mapRef = mapRef;
    onRefResolve(mapRef);
  };

  handleZoomChange = () => {
    const { mapRef } = this;
    const { onZoomChange = () => {} } = this.props;
    const zoom = mapRef.getZoom();
    this.setState({ zoom });
    onZoomChange(zoom, getBoundariesFromGoogleMap(mapRef));
  };

  handleDragEnd = () => {
    const { mapRef } = this;
    const { onDragEnd = () => {} } = this.props;
    const center = mapRef.getCenter();
    this.setState({ center });

    onDragEnd(center, getBoundariesFromGoogleMap(mapRef));
  };

  render() {
    const { handleDragEnd, handleZoomChange, handleMapRef } = this;

    const { children, ...props } = this.props;

    return (
      <GoogleMap
        ref={handleMapRef}
        options={MAP_OPTIONS}
        onZoomChanged={handleZoomChange}
        defaultZoom={ZOOM_LEVELS.DEFAULT}
        {...props}
        onDragEnd={handleDragEnd}
        center={this.center}
        zoom={this.zoom}
      >
        {children}
      </GoogleMap>
    );
  }
}

const Map = compose(
  ConfigHelperHOC,
  withProps(({ publicConfig }) => ({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${publicConfig.api.services.maps.key}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />
  })),
  withScriptjs,
  withGoogleMap
)(MapContainer);

export default Map;
